import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query reasonForTerminationWorkActive {
        reasonForTerminationWorkActive {
            id
            is_active
            name
            status_text
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query reasonForTerminationWorkWithPagination ($page: Int, $perPage: Int) {
        reasonForTerminationWorkWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                is_active
                status_text
            }
        }
    }
`

/**
 * Mutations
 */
const CREATE = gql`
    mutation createReasonForTerminationWork ($input: ReasonForTerminationWorkForm!) {
        createReasonForTerminationWork (input: $input) {
            id
            name
            is_active
            status_text
        }
    }
`

const UPDATE = gql`
    mutation updateReasonForTerminationWork ($id: ID!, $input: ReasonForTerminationWorkForm!) {
        updateReasonForTerminationWork (id: $id, input: $input) {
            id
            name
            is_active
            status_text
        }
    }
`

const DELETE = gql`
    mutation deleteReasonForTerminationWork ($id: ID!) {
        deleteReasonForTerminationWork (id: $id) {
            id
        }
    }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE
}
